import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { SoldVehicleRow } from "@/lib/sold-vehicle.server";
import { findSoldVehicle, listSoldVehicles } from "@/lib/sold-vehicle.server";

export type { SoldVehicleRow };

export const getSoldVehicles = createServerFn({ method: "GET" }).handler(
  async (): Promise<SoldVehicleRow[]> => listSoldVehicles(),
);

export const getSoldVehicle = createServerFn({ method: "GET" })
  .inputValidator((data) => z.object({ slug: z.string().min(1) }).parse(data))
  .handler(async ({ data }): Promise<{ item: SoldVehicleRow | null }> => ({
    item: await findSoldVehicle(data.slug),
  }));
